import { render, staticRenderFns } from "./FrontDesk.vue?vue&type=template&id=0543b73c&scoped=true&"
import script from "./FrontDesk.vue?vue&type=script&lang=js&"
export * from "./FrontDesk.vue?vue&type=script&lang=js&"
import style0 from "./FrontDesk.vue?vue&type=style&index=0&id=0543b73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543b73c",
  null
  
)

export default component.exports